import { render } from "./ApplicationRoles.vue?vue&type=template&id=0a534e0a&ts=true"
import script from "./ApplicationRoles.vue?vue&type=script&lang=ts"
export * from "./ApplicationRoles.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__